import { endOfSkippable } from "./end-of-skippable";
import { quotedFieldAt } from "./quoted-field-at";

/** A quoted `field:` at the object's OWN level, ignoring anything nested in it. */
export function topLevelStringField(
  literal: string,
  field: string,
): string | undefined {
  let depth = 0;
  let found: string | undefined;
  for (let at = 0; at < literal.length; at += 1) {
    // Before skipping: a JSON-style key opens with the quote we would skip.
    if (depth === 1) {
      // Last wins, as it does when JavaScript builds the object.
      const value = quotedFieldAt(literal, at, field);
      if (value !== undefined) found = value;
    }
    const skipped = endOfSkippable(literal, at);
    if (skipped !== at) {
      at = skipped;
      continue;
    }
    const char = literal[at];
    if (char === "{" || char === "[") depth += 1;
    else if (char === "}" || char === "]") depth -= 1;
  }
  return found;
}
